import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import withTheme from "@mui/styles/withTheme";
import styled from "styled-components";
import Color from "../../../assets/colors";

export const Wrapper = styling("div")({
  margin: "2.5rem 8.7% 4.375rem",
  height: "100%",

  "@media (max-width: 640px)": {
    margin: "1.25rem 1.5rem 2.5rem",
  },
});

export const CompanyListContainer = styling("div")({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "3rem",

  "@media (max-width: 1279px)": {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  "@media (max-width: 640px)": {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
});

export const PaginationWrapper = styling("div")({
  display: "flex",
  justifyContent: "center",

  width: "100%",
  margin: "1.875rem 0",
});

export const PaginationNumberBox = withTheme(styled(Box)`
  && {
    border-radius: 0.25rem;
    background-color: ${(props) =>
      props.$non_focus === "true" ? null : Color.hiredlyPurple};
    color: ${(props) =>
      props.$non_focus === "true" ? "#00000040" : Color.white};
    margin: ${(props) => (props.$margin === "true" ? "0 1.25rem" : null)};
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`);

export const PageNumber = styling(Typography)({
  //
});

export const IconButtonStyled = withTheme(styled(IconButton)`
  && {
    position: ${(props) =>
      props.$position === "absolute" ? "absolute" : null};
    right: ${(props) => (props.$right === "true" ? "0" : null)};
    top: ${(props) => (props.$top === "true" ? "0.5rem" : null)};
    margin-left: ${(props) =>
      props.$margin_left === "true" ? "0.5rem" : null};
    margin-right: ${(props) =>
      props.$margin_right === "true" ? "0.5rem" : null};
    background-color: ${(props) =>
      props.$pagination === "true" ? Color.grey : null};
    color: ${(props) => (props.$pagination === "true" ? Color.darkGrey : null)};
    width: ${(props) => (props.$pagination === "true" ? "2rem" : null)};
    height: ${(props) => (props.$pagination === "true" ? "2rem" : null)};
    border-radius: ${(props) =>
      props.$pagination === "true" ? "0.25rem" : null};

    &:hover {
      color: ${(props) =>
        props.$pagination === "true" ? Color.hiredlyPurple : null};
      background-color: ${(props) =>
        props.$pagination === "true" ? Color.grey : null};
    }
  }
`);

export const ChevronLeftIconStyled = styling(ChevronLeftIcon)({
  width: "1.25rem",
  height: "1.25rem",
});

export const ChevronRightIconStyled = styling(ChevronRightIcon)({
  width: "1.25rem",
  height: "1.25rem",
});
